import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
// import { createListGeneration, updateListGenerationById, getListGenerationById } from "../../../../../services/listGeneration.service";
import {
  TListGenerationForm,
  listGenerationSchema,
} from "./listGenerationSchema";
import {
  AutoComplete,
  FormContainer,
  FormInput,
  Treturn,
} from "@4uhub/lib4uhub";
import { listGeneration } from "../list-generation.mock";
import { generationRuleItems } from "../../GenerationRule/generation-rule.mock";

const translationPath = "page.4uDlist.listGeneration.";

const ListGeneration = () => {
  const { t } = useTranslation();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createListGeneration
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateListGenerationById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getListGenerationById
  //   );

  const saveHandler = async (v: TListGenerationForm) => {
    // save({
    //   ...v,
    // });
    const lastItemId = listGeneration[listGeneration.length - 1]?.id;
    const id = parseInt(lastItemId) + 1;
    return { data: { id }, success: true };
  };

  const updateHandler = async (v: TListGenerationForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TListGenerationForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TListGenerationForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      const data = listGeneration.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  //   const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TListGenerationForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      //   loading={loading}
      title={t(translationPath + "list_generation")}
      schema={listGenerationSchema}
      subtitle={t(translationPath + "new_list_generation")}
      subtitleWatchField="name"
      fields={() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormInput
              name="name"
              label={t(translationPath + "name")}
              fullWidth
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AutoComplete
              name="generationRule"
              size="small"
              options={generationRuleItems}
              label={t(translationPath + "generation_rule")}
              getOptionLabel={(option) => option.name}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default ListGeneration;
